// extracted by mini-css-extract-plugin
export default {"button_icon":"CreateRoomModal_button_icon__Ecvot","content":"CreateRoomModal_content__I+muc","title":"CreateRoomModal_title__eGwWM","text":"CreateRoomModal_text__HMrvw"};